export const QUERY_KEY_VIDEO_STREAMS = 'video-streams'